// JOBE-0162.4: OrganizationSearch — text input above the filter row.
//
// State is owned by the page (so it can debounce + thread into
// applyFilters); this component is the dumb input. The label is
// `aria-label`-only — we lean on the placeholder for visible affordance
// to keep the chrome compact.

import React from 'react';

/**
 * @param {object} props
 * @param {string} props.value
 * @param {(next: string) => void} props.onChange
 * @param {string} [props.placeholder]
 */
export function OrganizationSearch({
  value,
  onChange,
  placeholder = 'Search people and agents…',
}) {
  return (
    <input
      type="search"
      className="org-search-input"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label="Search organization"
      data-testid="organization-search"
    />
  );
}
